var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"px-6 py-3 bg-gray-50 text-xs font-medium text-gray-500 uppercase tracking-wider",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }